import { useSelector } from "react-redux";

import { getInitialViewstate } from "../state/simulation";

import DeckGlLayers from "./DeckGlLayers";

const MainMap = () => {
  const initialViewState = useSelector(getInitialViewstate);

  if (initialViewState === null) {
    return null;
  }

  return (
    <div
      style={{
        overflow: "hidden",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
      }}
    >
      <DeckGlLayers></DeckGlLayers>
    </div>
  );
};

export default MainMap;
